<template>
  <el-dialog
    :visible.sync="visible"
    title="图片识别"
    width="480px"
    top="20vh"
    append-to-body
    :close-on-click-modal="false"
    :lock-scroll="false"
    @close="hide"
  >
    <div class="upload-body">
      <div v-show="imgFileUrl" class="upload-fill">
        <div class="file-img-box relative" @click="showImgCutter">
          <img class="file-img" :src="imgFileUrl" />
          <div class="absolute top-0 right-0">
            <el-icon :size="20">
              <i class="el-icon-circle-close" @click.stop="clearImgFile"></i>
            </el-icon>
          </div>
        </div>
        <div class="mt-4">
          * 点击图片可对当前图片进行编辑，确认图片无误后请点击【上传（F1）】按钮进图片识别
        </div>
        <div class="mt-4">
          <el-input
            v-show="vin"
            v-model="vin"
            maxlength="17"
            :show-word-limit="true"
            placeholder="请输入内容"
            clearable
          >
          </el-input>
        </div>
        <div v-show="vin" class="dialog-footer flex justify-center m-2">
          <el-button size="small" type="primary" @click="parseVin">
            开始解析
          </el-button>
        </div>
      </div>
      <div v-show="!imgFileUrl">
        <el-upload
          action="#"
          :before-upload="beforeUpload"
          :auto-upload="false"
          :show-file-list="false"
          class="upload-demo mb-5"
          drag
          :on-change="handleChange"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <span>将图片拖拽到这里或者复制图片后在此处按 【CtrL+V】粘贴或</span>
            <em>点击此处选择本地图片</em>
          </div>
          <template #tip>
            <div class="el-upload__tip">
              支持扩展名：.pdf .jpg .png；图片大小在5M以内，仅支持上传1张图片
            </div>
          </template>
        </el-upload>
      </div>
    </div>
    <div v-show="imgFileUrl && nowEvent" class="dialog-footer flex justify-center m-2">
      <el-button size="small" @click="hide">取消</el-button>
      <el-button size="small" type="primary" @click="readFile">
        上传（F1）
      </el-button>
    </div>
    <ImgCutter ref="imgCutterRef" @get-cut-file="getCutFile" />
  </el-dialog>
</template>

<script>
import { Loading as ElLoading } from "element-ui";
import hotkeys from "hotkeys-js";
// import Compressor from "compressorjs";
import { compressAccurately } from "image-conversion";
// 使用时直接调用 compressAccurately
import ImgCutter from "./ImgCutter.vue";
import { getOCRVin } from "@/api/goods/index.js";

export default {
  name: "ImgUploadDialog",
  components: {
    ImgCutter
  },
  props: {
    imgUploadVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      keyScope: Symbol("imgLayout"),
      imgFile: null,
      imgFileUrl: "",
      nowEvent: null,
      fileList: [],
      vin: ""
    };
  },
  watch: {
    imgUploadVisible: {
      immediate: true,
      handler(newVal) {
        this.imgFileUrl = "";
        this.vin = "";
        this.visible = newVal;

        if (this.visible) {
          document.addEventListener("paste", this.getClipboardFiles);
        } else {
          document.removeEventListener("paste", this.getClipboardFiles);
        }
      }
    },
    imgFileUrl() {
      this.vin = "";
    }
  },
  mounted() {
    hotkeys("f1", (event, handler) => {
      switch (handler.key) {
        case "f1":
          this.readFile();
          break;
        default:
          break;
      }
    });
    hotkeys.setScope(this.keyScope.toString());
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.getClipboardFiles);
  },
  methods: {
    beforeUpload() {
      return false;
    },
    handleChange(uploadFile) {
      const file = uploadFile.raw;
      this.imgFile = file;
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgFileUrl = String(reader.result);
        this.nowEvent = {
          target: {
            files: [this.imgFile]
          }
        };
      });
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    showImgCutter() {
      if (this.imgFileUrl) {
        this.$refs.imgCutterRef.show(this.imgFileUrl);
      }
    },
    clearImgFile() {
      this.imgFileUrl = "";
      this.nowEvent = null;
    },
    parseVin() {
      this.$emit("change", this.vin);
      this.hide();
    },
    hide() {
      this.$emit("close", false);
    },
    getCutFile(cutFile) {
      // const file = this.dataURLtoFile(cutFile, "test.png");
      this.imgFile = cutFile;
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgFileUrl = String(reader.result);
        this.nowEvent = {
          target: {
            files: [this.imgFile]
          }
        };
      });
      if (cutFile) {
        reader.readAsDataURL(cutFile);
      }
    },
    getClipboardFiles(event) {
      const items = event.clipboardData && event.clipboardData.items;
      let file = null;
      if (items && items.length) {
        // 检索剪切板items
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            file = items[i].getAsFile();
            const reader = new FileReader();
            reader.addEventListener("load", () => {
              this.imgFileUrl = String(reader.result);
              this.imgFile = file;
              this.nowEvent = {
                target: {
                  files: [file]
                }
              };
            });
            if (file) {
              reader.readAsDataURL(file);
            }
          }
        }
      }
      if (!file) {
        this.$message({
          message: "粘贴内容不是图片",
          type: "error"
        });
      }
    },
    readFile() {
      if (this.imgFile) {
        const inputFile = this.imgFile;
        const loading = ElLoading.service({
          lock: true,
          text: "识别中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        // 图片压缩
        if (inputFile.size > 6000000) {
          new Compressor(inputFile, {
            quality: 0.1,
            success: result => {
              if (result.size > 1000000) {
                compressAccurately(result, 300).then(file => {
                  this.file2Xce(file).then(res => {
                    this.vinParse(loading, res, file.type);
                  });
                });
                return;
              }
              this.file2Xce(result).then(res => {
                this.vinParse(loading, res, result.type);
              });
            }
          });
        } else if (inputFile.size > 600000) {
          compressAccurately(inputFile, 300).then(file => {
            this.file2Xce(file).then(res => {
              this.vinParse(loading, res, file.type);
            });
          });
        } else {
          this.file2Xce(inputFile).then(res => {
            this.vinParse(loading, res, inputFile.type);
          });
        }
      }
    },
    file2Xce(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
          const data = e.target.result;
          resolve(data);
        };
        reader.readAsDataURL(file);
      });
    },
    vinParse(loading, fileData, fileType) {
      const imgCode = fileData.replace(`data:${fileType};base64,`, "");
      getOCRVin(imgCode)
        .then(res => {
          loading.close();
          if (res) {
            this.vin = res;
            this.nowEvent = null;
          } else {
            this.$message({
              message: "未识别到vin码",
              type: "info"
            });
          }
        })
        .catch(err => {
          loading.close();
          if (err && err.message) {
            this.$message({
              message: err.message,
              type: "error"
            });
          }
        });
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-body {
  box-sizing: border-box;
  padding: 16px;
  text-align: center;
  .upload-fill {
    .file-img-box {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      padding: 8px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #eee;
      border-radius: 2px;
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .file-img {
        max-width: 100%;
        max-height: 100%;
      }
      .el-icon-error {
        position: absolute;
        right: -7px;
        top: -7px;
        font-size: 14px;
        color: #bfbfbf;
        cursor: pointer;
      }
    }
  }
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.mt-4 {
  margin-top: 1rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}
</style>
